'use strict';

const _ = require('lodash');
const validations = require('./validations');
const checkBaseTypes = require('./checkBaseTypes');

module.exports = function (obj, schema) {
  var validationResponse = {
    valid: true,
    hasWarnings: false,
    validation: {}
  };

  if (!obj) {
    validationResponse.valid = false;
    return validationResponse;
  }

  if (!schema) {
    return validationResponse;
  }

  var parsedObj = checkBaseTypes(obj, schema);

  _.each(_.keys(schema), function (fieldName) {
    validationResponse.validation[fieldName] = [];

    var parsedValue = parsedObj[fieldName];

    if (!parsedValue.valid) {
      validationResponse.validation[fieldName].push({
        message: parsedValue.message,
        severity: 'error'
      });
      validationResponse.valid = false;
      return;
    }

    var rules = schema[fieldName].rules;

    if (rules) {
      _.each(rules, function (rule) {
        var validationMethod = validations[rule.type];
        var config = rule.config;

        if (validationMethod === undefined) {
          throw new Error('Could not find validation method ' + rule.type);
        }

        var response = validationMethod(obj, fieldName, config, rule);

        if (response === false) {
          var severity = rule.severity || 'error';

          var msg = {
            message: _.isFunction(rule.message) ? rule.message(obj, fieldName, config, rule) : rule.message,
            severity: severity
          };

          if (severity === 'error') {
            validationResponse.valid = false;
          } else {
            validationResponse.hasWarnings = true;
          }

          validationResponse.validation[fieldName].push(msg);
        }
      });
    }
  });

  return validationResponse;
};
